import React, { useEffect, useState } from 'react'
import { MdErrorOutline } from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import LoadingContainer from '../../controls/LoadingContainer'
import Empty from '../../controls/Empty'
import { IoMdOpen } from 'react-icons/io'
import { Link, useParams } from 'react-router-dom'
import Paging from '../../controls/Paging'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import Input from '../../controls/Input'
import * as publicUserCrud from '../../../configurations/crud/publicUserCrud'
import { PAGE_SIZE } from '../../../configurations/initUrls'
import useDebounce from '../../../configurations/commonlib/useDebounce'
import moment from 'moment'
import { EBoolBg, GetEBoolName } from '../../../configurations/enums/EBool'
import StatusContainer from '../../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource'
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType'
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import Datepicker from 'react-tailwindcss-datepicker'
import { EOPDRegisteredStatusBg, GetEOPDRegisterStatusName } from '../../../configurations/enums/EOPDRegisteredStatus'
import { GetEGenderName } from '../../../configurations/enums/EGender'
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import MasterPage from '../MasterPage'
import Card from '../../controls/Card'
import MaterialCard from './MaterialCard'
import GlobalPaging from '../../controls/GlobalPaging'
const NEXT_MONTH = new Date();
NEXT_MONTH.setMonth(NEXT_MONTH.getMonth() - 1);
//const TODAY = new Date();

export default function MyRegister() {

  const { phoneNo } = useParams()
  const initValues = {
    PhoneNo: phoneNo,
    PageNo: 1,
    PageSize: PAGE_SIZE,
    SearchTerm: "",
  }
  const { start, end } = useGlobalLoader()
  const toast = useToast()
  const [loding, setLoding] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState(initValues);
  const [LastPage, setLastPage] = useState(1);
  const [pagingData, setPagingData] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDebounce, setSearchDebounce] = useDebounce("", 700);

  useEffect(() => {
    setSearchDebounce(searchTerm)
  }, [searchTerm])

  useEffect(() => {
    onSearch()
  }, [searchDebounce])

  const OnPageChange = (e) => {
    setSearch({ ...search, PageNo: e })
    onSearchNew({
      PhoneNo: search.PhoneNo,
      PageNo: e,
      PageSize: search.PageSize,
      SearchTerm: search.SearchTerm,
    })
  }

  const onSearchChange = (e) => {
    setSearchTerm(e.target.value)
  }

  const onSearch = () => {
    onSearchNew({
      PhoneNo: search.PhoneNo,
      PageNo: 1,
      PageSize: search.PageSize,
      SearchTerm: searchTerm,
    })
  }

  const onSearchNew = (search) => {
    fetchMyRegister(search)
  }
  const fetchMyRegister = (params) => {
    setLoding(true)
    start()
    publicUserCrud.GetAllRegistered(params).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setUserData(mdata.data)
        setPagingData(mdata.paging)
        setLastPage(mdata.paging.pageCount)
      } else {
        setPagingData()
        setLastPage(1)
        setUserData([])
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      console.log(errors)
      setPagingData()
      setLastPage(1)
      setUserData([])
      setLoding(false)
      end()
      toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
    })
  }

  return (
    // <MasterPage>
    //   <div className='flex flex-col '>
    //     <div className='flex flex-col sm:flex-row sm:space-x-3'>
    //       <div className='w-full py-3'>
    //         <Input Icon={<FontAwesomeIcon color='gray' icon={faSearch} />}
    //           onChange={onSearchChange}
    //           placeholder="Search..."></Input>
    //       </div>
    //     </div>
    //     <Paging LastPage={LastPage} CurrentPage={search.PageNo} OnPageChange={OnPageChange} pagingData={pagingData} >
    //       <div class="overflow-x-auto">
    //         {
    //           !loding ?
    //             userData.length > 0 ?
    //               <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
    //                 <thead class="text-xs text-gray-700 uppercase bg-gray-200">
    //                   <tr>
    //                     <th scope="col" class="px-2 py-3">
    //                       <div class="flex items-center">
    //                         <input id="checkbox-all" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
    //                         <label for="checkbox-all" class="sr-only">checkbox</label>
    //                       </div>
    //                     </th>
    //                     <th scope="col" class="px-8 py-3 ">
    //                       Center
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       #
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Patient Name
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Gender
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Address
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Phone
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Age/Weight
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Note
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Time
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Reserved
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Status
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Source
    //                     </th>
    //                     <th scope="col" class="px-2 py-3">
    //                       Type
    //                     </th>
    //                   </tr>
    //                 </thead>
    //                 <tbody>
    //                   {userData.map((item, index) =>
    //                     <tr class="bg-white border-b hover:bg-gray-100">
    //                       <td class="w-4 px-2 py-2">
    //                         <div class="flex items-center">
    //                           <input id="checkbox-table-search-1" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500  focus:ring-2 " />
    //                           <label for="checkbox-table-search-1" class="sr-only">checkbox</label>
    //                         </div>
    //                       </td>
    //                       <td class="px-2 py-2 text-center">
    //                         {item.opdCenter.id}) {item.opdCenter.centerName}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {item.id}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {item.patientName}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {GetEGenderName(item.gender)}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {item.patientAddress}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {item.mobile}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {item.age}/{item.weight}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {item.note ? item.note : "N/A"}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         {moment(item.onDate).format("DD/MMM/YYYY")}
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         <StatusContainer bg={EBoolBg(item.isReserved)} text={GetEBoolName(item.isReserved)} />
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         <StatusContainer bg={EOPDRegisteredStatusBg(item.status)} text={GetEOPDRegisterStatusName(item.status)} />
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         <StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} />
    //                       </td>
    //                       <td class="px-2 py-2">
    //                         <StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} />
    //                       </td>
    //                     </tr>
    //                   )}

    //                 </tbody>
    //               </table>
    //               : <Empty>
    //                 No Items Found.
    //               </Empty>
    //             : <LoadingContainer />
    //         }
    //       </div>
    //     </Paging>
    //   </div>
    // </MasterPage>
    <MasterPage>
      <div className='mb-4 mx-2 sm:mx-4 flex items-center justify-center'>
        <div className='w-full lg:w-2/3'>
          <div className="w-full flex-row md:flex px-2 pb-3">
            <div className="w-full">
              <Card
                title={"My Register"}
                isBorder={true}
                borderColor="border-brand-400"
                isBack={true}
              >
                <div className='flex flex-col sm:flex-row sm:space-x-3 my-3'>
                  <div className='w-full'>
                    <Input
                      Icon={<FontAwesomeIcon color='gray' icon={faSearch} />}
                      onChange={onSearchChange}
                      placeholder="Search..."
                    />
                  </div>
                </div>
              </Card>
            </div>
          </div>

          <div className="my-5" />

          <div className="w-full px-2 pb-3">
            <div className="w-full">

              <GlobalPaging
                text={"Records"}
                LastPage={LastPage} CurrentPage={search.PageNo}
                OnPageChange={OnPageChange}
                pagingData={pagingData}
                loading={loding}>
                <div>
                  {
                    !loding ?
                      userData.length > 0 ?
                        <div className='w-full flex flex-col gap-4'>
                          {userData.map(item =>
                            <MaterialCard item={item} />
                          )}
                        </div>
                        :
                        <Empty>
                          No Items Found.
                        </Empty>
                      :
                      <LoadingContainer />
                  }
                </div>
              </GlobalPaging>
            </div>
          </div>
        </div>
      </div>
    </MasterPage>
  )
}
